import {Component, Input, OnInit} from '@angular/core';
import {DriverSosDescription} from '../../../../services/banners.service';

@Component({
  selector: 'app-driver-sos-description',
  templateUrl: './driver-sos-description.component.html',
  styleUrls: ['./driver-sos-description.component.scss']
})
export class DriverSosDescriptionComponent implements OnInit {

  @Input() descriptionConfig: DriverSosDescription;

  constructor() { }

  ngOnInit() {
  }

}
